//下载中心
import DownloadCenter from '@/pages/download/list.vue'


export default [{
  path: '/download/list',
  component: DownloadCenter,
  meta: {
    title: '下载中心'
  },
}]



// WEBPACK FOOTER //
// ./src/router/module/download.js